import Facade from '../Facade'

export class RestoreUtil {
    public static readonly MUSIC_KEY = 'music'
    public static readonly SOUND_KEY = 'sound'
    public static readonly VOLUME_KEY = 'volume'
    public static readonly SKIP_INTRO_KEY = 'skipIntro'
    public static readonly SPACEBAR_SPIN_KEY = 'spacebarSpin'
    public static readonly TURBO_SPIN_KEY = 'turboSpin'

    public static getKeyData = (key: string): any => {
        return JSON.parse(localStorage.getItem(Facade.urlParams.playerUid + key))
    }

    public static setKeyData = (key: string, data: string) => {
        localStorage.setItem(Facade.urlParams.playerUid + key, data)
    }
}
